import React from 'react'
import "../styles/Chatbot.css"

function Chatbot() {
  return (
    <div>
        <input className='message-brig' placeholder='Message Brig.ai'></input>
    </div>
  )
}

export default Chatbot